<div class="row">
	<div class="{{ classCol }}">
		<label for="amountOf" class="form-label">
			{{ amountFromLabel | translate }}
		</label>
		<input
			class="form-control"
			type="text"
			inputRestriction="configuredDecimal"
			[configurationNumber]="deviseInfo?.nombreDecimales"
			[withAmountSeparation]="true"
			[formControl]="amountFromControl"
			[class.is-invalid]="amountFromControl?.dirty && amountFromControl?.invalid"
		/>
		<form-control-feedback [field]="amountFromControl"></form-control-feedback>
	</div>
	<div class="{{ classCol }}">
		<label for="montant" class="form-label">
			{{ amountToLabel | translate }}
		</label>
		<input
			class="form-control"
			type="text"
			inputRestriction="configuredDecimal"
			[configurationNumber]="deviseInfo?.nombreDecimales"
			[withAmountSeparation]="true"
			[formControl]="amountToControl"
			[class.is-invalid]="amountToControl?.dirty && amountToControl?.invalid"
		/>
		<form-control-feedback [field]="amountToControl"></form-control-feedback>
	</div>
</div>
